import { render } from "./mpermissiontree.vue?vue&type=template&id=62f96971&scoped=true"
import script from "./mpermissiontree.vue?vue&type=script&lang=js"
export * from "./mpermissiontree.vue?vue&type=script&lang=js"

import "./mpermissiontree.vue?vue&type=style&index=0&id=62f96971&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f96971"]])

export default __exports__